import { render, staticRenderFns } from "./FinalJuniorProfileStage.vue?vue&type=template&id=28ad38da&"
import script from "./FinalJuniorProfileStage.vue?vue&type=script&lang=js&"
export * from "./FinalJuniorProfileStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports